import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell } from "@/components/AuthShell";
import { MASCOT } from "@/lib/api";

export default function InactiveSubscription() {
  const { logout } = useAuth();
  const navigate = useNavigate();

  return (
    <AuthShell
      title="Assinatura inativa"
      subtitle="Seu acesso ao painel está pausado, mas seus produtos continuam guardados."
      mascot={MASCOT.tilt}
    >
      <div className="space-y-4 text-center">
        <p className="text-[#5c4634] text-sm">
          Assim que a assinatura for reativada, você volta a criar anúncios normalmente —
          nenhum produto foi apagado.
        </p>
        <button onClick={() => navigate("/#planos")} className="btn-orange w-full py-3.5 rounded-full font-semibold" data-testid="reactivate-btn">
          Reativar assinatura
        </button>
        <button onClick={() => { logout(); navigate("/login"); }} className="w-full py-3 rounded-full font-medium text-[#8c735f] hover:text-[#d9640d]" data-testid="inactive-logout">
          Sair
        </button>
      </div>
    </AuthShell>
  );
}
